import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3609c964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainFirst" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_3 = { class: "flexCenter" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重 置")

import { reactive,ref } from 'vue'
	import { requestChangepwd } from '@/api/api'
	import { ElMessage } from 'element-plus'
	import { useRouter } from 'vue-router'
	interface pwdType {
		oldpwd: string
		newpwd1: string
		newpwd2: string
	}
	
export default /*#__PURE__*/_defineComponent({
  name: 'PassWord',
  setup(__props) {

	const router = useRouter()
	const ruleForm = reactive<pwdType>({
		oldpwd: '',
		newpwd1: '',
		newpwd2:''
	})
	const submit = () => {
		if(ruleForm.oldpwd === ""){
			ElMessage.error("原密码不能为空");
			return
		}
		requestChangepwd({
			oldpwd:ruleForm.oldpwd,
			newpwd1:ruleForm.newpwd1,
			newpwd2:ruleForm.newpwd2
		}).then((res:any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "修改成功(1秒后自动退出)",
			        type: 'success',
			        duration: 1000
			    });
				setTimeout(()=>{
					router.push({path:'/'})
				},1000)
			}else{
				ElMessage({
				    message: res.msg,
				    type: 'error',
				    duration: 500
				});
			}
		})
	}
	const cz = () => {
		ruleForm.oldpwd = ''
		ruleForm.newpwd1 = ''
		ruleForm.newpwd2 = ''
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      style: {width:'30%'},
      "label-width": "100px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "原密码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "password",
              modelValue: ruleForm.oldpwd,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.oldpwd) = $event)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (submit()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "新密码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "password",
              modelValue: ruleForm.newpwd1,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.newpwd1) = $event)),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (submit()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "确认密码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "password",
              modelValue: ruleForm.newpwd2,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.newpwd2) = $event)),
              onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (submit()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (submit())),
            type: "primary",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (cz())),
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})